export enum VacaniesStatusTypesEnums {
  'PUBLISHED' = 1,
  'DRAFT' = 10,
}
